import {OnInit, Component} from '@angular/core';
import {Slide} from './slide.component';
import {Carousel} from './carousel.component';
import {ProductService} from "../product.service";
import {Product} from "../product";
import {Router} from "@angular/router";
import {ShoppingCart} from "../shoppoingcart.component";
import {AddButton} from "../cartbutton.component";
import {SearchValue} from "../searchvalue.service";
import {NewService} from "../news/new.service";
import {New} from "../news/new";
import {LineComponent} from "./line.component";
import {AboutComponent} from "./about.component";
import {OrderByPipe} from "./orderBy";
import { NgModule } from '@angular/core'
//import {escape} from "@angular/common/src/facade/lang";

@Component({
  template: `
        
        <div class="container">
        
        </div>
        <div class="detail">
        <div class="info_content">
					<div class="info">
						<div class="searchbar"><br>
							<div class="search">
							<div class="search1">
							   <span>
							   品牌分類
							   <select style="width: 7em;border-radius: .25em;" #brand>
							                 <option value="">所有品牌</option>
							                 <option value="Butterfly">BUTTERFLY</option>
							                 <option value="Stiga">STIGA</option>
                               <option value="Nittaku">Nittaku</option>
                               <option value="Xion">XIOM</option>                                                        
                               <option value="Donic">DONIC</option>
                               <option value="Yasaka">Yasaka</option>
                               <option value="Tibhar">TIBHAR</option>
                               <option value="Andro">andro</option>
                               <option value="Dr.Neubauer紐鮑爾">Dr.Neubauer</option>
                               <option value="Mizuno">MIZUNO</option>
                               <option value="Tsp">TSP</option>
                               <option value="Victas">VICTAS</option>
                               <option value="Joola">JOOLA</option>
                               <option value="Adidas">adidas</option>
                               <option value="紅雙喜DHS">紅雙喜DHS</option>
                               <option value="Crack">Crack</option>
                               <option value="台灣神木">STARWOOD</option>
                               <option value="銀河">銀河</option>
                               <option value="others">其它品牌</option>                                                                                      
							   </select>
							   </span>
                               <span>                      
							   商品分類
							   <select style="width: 7em;border-radius: .25em;" #category>
							   <option value="">所有分類</option>
                                 <option value="blades">刀板</option>
                                 <option value="penhold">直板</option>
                                 <option value="robbers">膠皮</option>
                                <option value="clothes">服飾</option>
                                <option value="shoes">鞋&襪</option>
                                <option value="bags">拍套&裝備袋(包)</option>
                                <option value="lowblades">成品拍</option>
                                 <option value="balls">球&置球盒</option>
                                 <option value="tables">球桌&周邊，發球機</option>
                                 <option value="glue">膠水&增能劑</option>   
                                <option value="accessory">配件&保養清潔品</option>                                
                                <option value="others">其他商品</option>
							   </select></span>  
							   <button (click)="gotoResult(brand.value,category.value)">商品搜尋</button>
							</div> 
                            </div>
						</div>
						
						<div class="leftInfo">
						<h3>波爾桌球用品專賣店<br>BOLL TABLETENNIS SHOP<button (click)="gotoAbout()" style="float: right;margin-left: 10px;">關於我們</button><br></h3>
                        <p>我們希望讓每一把拍子找到它的主人，而每個球友都帶著最適合自己的拍子離開...一直是我們成立波爾桌球用品專賣店的使命...<br>
					              </p>
					    <div class="bothImg" align="center">
					    <span class="leftImg">
					    <a href="mailto:majestic168168@gmail.com" ><img src="../../img/telephone.png" height="70px" width="70px"></a><h3>(02)3151-7171</h3>
					    
					    </span>
					    <span class="rightImg">
					    <img data-toggle="modal" data-target="#lineModal" src="../../img/line.png" height="70px" width="70px"><h3>ID 0986465666</h3><h6>(回覆時間：PM1點~7點)</h6>
					    </span>
					    
					    </div>
              <!-- Modal -->
                  <div class="modal fade" id="lineModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div class="modal-dialog lineModal" role="document" style="padding-top: 100px;">
                      <div class="modal-content" style="width: 200px;min-height: 200px">
                        <div class="modal-header">
                          <button type="button" style="width: 20px;height: 20px;" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <h4 class="modal-title" id="myModalLabel">Line ID 0986465666</h4>
                        </div>
                        <div class="modal-body">
                          <img src="../../img/lineid.jpg">
                        </div>
                      </div>
                    </div>
                  </div>

					    </div>
					    
					    <div class="rightInfo"> 
					    
              <img src="../../img/pic.jpg" height="250px" width="460px">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3616.164028335365!2d121.5176433141931!3d24.994541746027817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9e1ff84c2df%3A0xe106e3ef4d0d45b4!2z5rOi54i-5qGM55CD55So5ZOB5bCI6LOj5bqX!5e0!3m2!1szh-TW!2stw!4v1586923009287!5m2!1szh-TW!2stw" width="460" height="150" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>  
              </div>
					
					</div>
					<div class="backinfo"></div>
					
				</div>
	
				<div class="banner">
				
				<div class="row">
                      <div class="col-md-12">
                        <carousel [interval]="NextPhotoInterval" [noWrap]>
                          <slide  *ngFor="let slidez of slides; let index=index"
                                 [active]="slidez.active" >
                            <img [src]="slidez.image" style="margin:auto;">

                            
                          </slide>
                        </carousel>
                      </div>
                    
                    </div>
				
                </div>
				
			  </div>
			  
			  <div class="news">
				<div class="news_img"></div>
				<div class="news_info">
					<h2>最新消息</h2><hr width="450px">
          <div class="new_btn">
          <button (click)="gotoDetail2()">2025-11-05<span class="category">新品</span><p></p>"STIGA" HELIX PLATINUM 膠皮👊🏻👊🏻👊🏻 到貨‼️‼️‼️</button>
          <button (click)="gotoDetail1()">2025-09-27<span class="category">新品</span><p></p>"BUTTERFLY" 最頂級膠皮 ZYRE-03 火熱供應中🔥</button> 
          <button (click)="gotoDetail6()">2025-07-18<span class="category">新品</span><p></p>"DONIC" 張繼科代言球拍到貨‼️‼️</button>
          <button (click)="gotoDetail5()">2025-07-08<span class="category">新品</span><p></p>"STIGA" 2025新款神仙球鞋到貨～📢📢</button>
          <button (click)="gotoDetail4()">2025-06-18<span class="category">新品</span><p></p>"DONIC" 2025 BLUEGRIP系列 膠皮火熱上市🔥🔥</button>
          <button (click)="gotoDetail3()">2025-06-06<span class="category">新品</span><p></p>"Nittaku" 2025 GENEXTION V2C 微黏膠皮到貨!!</button>
					</div>
					<div id="myModal5" class="modal fade" role="dialog" >
                      <div class="modal-dialog">
                    <!-- Modal content-->
                      <div class="modal-content">
                      <div class="ptitle"> {{ptitle}}</div>
                      <div class="pcontent">{{pcontent}}</div>
                      </div>
                      </div>
                      </div>
          <div class="new_button3"><button (click)="gotoClassroom()">更多花絮</button></div>                     
          </div>
          
			</div>
			
			
			<div class="commodity">
			<div class="title-clothes">
        <div class="title-clothes-line"></div>新品上架<div class="title-clothes-line2"></div>
        </div>
			<div class="commodity_raw productSlider" >
				<div class="col-md-2" *ngFor="let p of products | orderBy : '-json_str' ">
					<button type="button" data-toggle="modal" data-target="#myModal" (click)="onSelect(p.name,p.price,p.id,p.imgsrc,p.description,p.category,p.blade_structure,p.blade_special,p.blade_vibrate,p.blade_hitsize,p.blade_thick,p.blade_holdwidth,p.blade_holdsize,p.blade_madein,p.robber_property,p.robber_speed,p.robber_spin,p.robber_control,p.robber_hard,p.robber_madein,p.other_madein,p.brand)"><img src="{{p.imgsrc}}" alt=""></button>
					<div class="commodity_detail" id="name">{{p.name}}</div>
          <div class="commodity_detail" id="plogo">
            <img src="../../img/logo/{{p.brand}}.jpg" alt="">
          </div>
					<div class="commodity_detail" id="price"><span class="pricecol">＄{{p.price}}</span></div>					
					<!-- Modal -->
                    
                    <div id="myModal" class="modal fade" role="dialog" >
                      <div class="modal-dialog">
                    <!-- Modal content-->
                       <h2>{{pname}}</h2>
                      <div class="modal-content">
                     <div class="cool">
                     <button class="productClose" type="button" data-dismiss="modal"><i class="fa fa-times"></i></button>
                     <div class="modal-left">
                     <img class="product_img" src="{{pimg}}" alt="">
                     </div>
                     <div class="modal-right">
                     
                     
                     <div class="icon" *ngIf="pcategory=='blades' || pcategory=='penhold'"> 
                     <div class="icon1" align="center"><img src="../../img/icon/06.png"><p>底板結構</p><span class="pricecol"><p>{{pblade_structure}}</p></span></div>
                     <div class="icon1" align="center"><img src="../../img/icon/11.png"><p>震動特性</p><span class="pricecol"><p>{{pblade_vibrate}}</p></span></div>
                     
                     &nbsp;<div class="icon1" align="center"><img src="../../img/icon/08.png"><p>&nbsp;反發特性</p><span class="pricecol"><p>{{pblade_special}}</p></span></div>
                    <div class="icon1" align="center"><img src="../../img/icon/09.png"><p>拍柄尺寸</p><span class="pricecol"><p>{{pblade_holdsize}}</p></span></div>
                    <br>  <div class="icon1" align="center"><img src="../../img/icon/10.png"><p>拍柄底寬</p><span class="pricecol"><p>{{pblade_holdwidth}}</p></span></div>
                     
                     <div class="icon1" align="center"><img src="../../img/icon/12.png"><p>板面尺寸</p><span class="pricecol"><p>{{pblade_hitsize}}</p></span></div>
                     <div class="icon1" align="center"><img src="../../img/icon/13.png"><p>板面厚度</p><span class="pricecol"><p>{{pblade_thick}}</p></span></div>
                     <div class="icon1" align="center"><img src="../../img/icon/05.png"><p>出產地</p><span class="pricecol"><p>{{pblade_madein}}</p></span></div>
                
                     </div> 
                     
                     <div class="icon" *ngIf="pcategory=='robbers'">   
                     
                    <div class="icon2" align="center"><img src="../../img/icon/01.png"><p>性質</p><span class="pricecol"><p>{{probber_property}}</p></span></div>
                    <div class="icon2" align="center"><img src="../../img/icon/07.png"><p>速度</p><span class="pricecol"><p>{{probber_speed}}</p></span></div>
                    <div class="icon2" align="center"><img src="../../img/icon/02.png"><p>旋轉</p><span class="pricecol"><p>{{probber_spin}}</p></span></div>
                     
                    <br> <div class="icon2" align="center"><img src="../../img/icon/03.png"><p>控制</p><span class="pricecol"><p>{{probber_control}}</p></span></div>
                     <div class="icon2" align="center"><img src="../../img/icon/04.png"><p>硬度</p><span class="pricecol"><p>{{probber_hard}}</p></span></div>
                     <div class="icon2" align="center"><img src="../../img/icon/05.png"><p>出產地</p><span class="pricecol"><p>{{probber_madein}}</p></span></div>
                     
                     </div>

                     <div class="icon" *ngIf="pcategory=='lowblades' || pcategory=='glue' || pcategory=='balls' || pcategory=='clothes' || pcategory=='shoes' || pcategory=='accessory' || pcategory=='bags' || pcategory=='tables'  || pcategory=='others' ">   
                     <div class="icon3" align="center"><img src="../../img/icon/05.png"><p>出產地</p><span class="pricecol"><p>{{pothers_madein}}</p></span></div>
                     </div>
                     
                     <div class="description">
                     <p>{{pdescription}}</p>
                     </div>       
                     <div class="button_panel">
                     
                     <button class="price-btn">＄{{pprice}}</button>
                     <select style="width: 4em;border-radius: .25em;height: 1.75em;background-color: #fff;color: #181896;font-size: 20px;" (change)="onChangeSelected($event.target.value)">
                     <option [value]=1 [selected]="pamount==1">1</option>
                     <option [value]=2>2</option>
                     <option [value]=3>3</option>
                     <option [value]=4>4</option>
                     <option [value]=5>5</option>
                     <option [value]=6>6</option>
                     <option [value]=7>7</option>
                     <option [value]=8>8</option>
                     <option [value]=9>9</option>
                     <option [value]=10>10</option>
                     </select>
                     <add [pprice]="pprice" [pid]="pid" [pamount]="pamount" [pname]="pname"></add>
                    
                     </div>
                     
                     </div>
                     
                     
                     </div>
    
                    </div>
    
                </div>
            </div>
				</div></div>
				
				
				
		   <div class="title-home">
        <div class="title-home-line"></div>各類商品<div class="title-home-line2"></div>
        </div>
		<div class="commodity_classify">
		    <div class="categorybtn">
					<div class="raw">
				<br/>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','blades')"><img src="../../img/category/blades.jpg" alt=""></button><span class="coool">刀板</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','penhold')"><img src="../../img/category/penhold.jpg" alt=""></button><span class="coool">直板</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','robbers')"><img src="../../img/category/robbers.jpg" alt=""></button><span class="coool">膠皮</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','clothes')"><img src="../../img/category/clothes.jpg" alt=""></button><span class="coool">服飾</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','shoes')"><img src="../../img/category/shoes.jpg" alt=""></button><span class="coool">鞋&襪</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','bags')"><img src="../../img/category/bags.jpg" alt=""></button><span class="coool">拍套&裝備袋(包)</span></div>
				</div>
				<div class="raw"><br/>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','lowblades')"><img src="../../img/category/lowblades.jpg" alt=""></button><span class="coool">成品拍</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','balls')"><img src="../../img/category/balls.jpg" alt=""></button><span class="coool">球&置球盒</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','tables')"><img src="../../img/category/tables.jpg" alt=""></button><span class="coool">球桌&周邊，發球機</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','glue')"><img src="../../img/category/glues.jpg" alt=""></button><span class="coool">膠水&增能劑</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','accessory')"><img src="../../img/category/accessory.jpg" alt=""></button><span class="coool">配件&保養清潔品</span></div>
					<div class="col-md-4 col-md-2" align="center"><button (click)="gotoResult('','others')"><img src="../../img/category/others.jpg" alt=""></button><span class="coool">其他</span></div>
				</div>
            </div>
			</div>
    
			
			
        
       
		
    `,
  inputs:['ptitle','pcontent','pamount','pprice','pid','pimg','pdescription','pcategory','pname','pblade_structure','pblade_special','pblade_vibrate','pblade_hitsize','pblade_thick','pblade_holdwidth','pblade_holdsize','pblade_madein','probber_property','probber_speed','probber_spin','probber_control','probber_hard','probber_madein','pothers_madein']
})



export class HomeComponent{
  NextPhotoInterval:number = 8000;
  //Looping or not
  noLoopSlides:boolean = true;
  //Photos
  slides:Array<any> = [];

  pname:string;
  pprice:number;
  pid:number;
  pamount:number;
  pimg:string;
  pdescription:string;
  pcategory:string;
  pblade_structure:string;
  pblade_special:string;
  pblade_vibrate:string;
  pblade_hitsize:string;
  pblade_thick:string;
  pblade_holdwidth:string;
  pblade_holdsize:string;
  pblade_madein:string;
  probber_property:string;
  probber_speed:string;
  probber_spin:string;
  probber_control:string;
  probber_hard:string;
  probber_madein:string;
  pothers_madein:string;
  ptitle:string;
  pcontent:string;
  pothers:string;
  pbrand:string;

  constructor(private productService:ProductService,private router:Router,private searchvalue:SearchValue,private newservice:NewService) {
    this.addNewSlide();
  }

   addNewSlide() {
    this.slides.push(
      {image:'../../img/1.jpg',text:'BMW 1'},
      {image:'../../img/2.jpg',text:'BMW 2'},
      {image:'../../img/3.jpg',text:'BMW 3'},
      {image:'../../img/4.jpg',text:'BMW 3'}
    );
  }

  removeLastSlide() {
    this.slides.pop();
  }

  gotoResult(value,value2){
    this.searchvalue.add(value,value2)
    this.router.navigate(['SearchResult']);
  }


  errorMessage:string;

  products:Product[];
  new:New[];

  ngOnInit(){
    this.getProducts();
    this.getNews();

  }
  getNews(){
    this.newservice.getNews()
      .subscribe(
        products => this.new = products,
        error =>  this.errorMessage = <any>error);


  }

  getProducts(){
    this.productService.getProduct()
      .subscribe(
        products => {

          //this.products = products;
          var sortedArray: Product[] = products.sort((obj1, obj2) => {
            if (+obj1.json_str > +obj2.json_str) {
              return 1;
            }

            if (+obj1.json_str < +obj2.json_str) {
              return -1;
            }

            return 0;
          });
          var NeedToSort:Product[]=[];
          var DontNeedToSort:Product[]=[];
          for(var i=0;i<sortedArray.length;i++){
            if(sortedArray[i].json_str!=""){
              NeedToSort.push(sortedArray[i]);
              delete sortedArray[i];
            }
          }
          DontNeedToSort =sortedArray.filter(Boolean);

          for(var i=0;i<DontNeedToSort.length;i++){
            NeedToSort.push(DontNeedToSort[i]);
          }

          this.products = NeedToSort.reverse();
        },
        error =>  this.errorMessage = <any>error);
  }

  select2(title:string,content:string){
    this.newservice.add(title,content);
  }

  onChangeSelected(amount:number){
    this.pamount=amount;
  }


  onSelect(name:string,product: number,productid:number,pimg:string,pdescription:string,pcategory,pblade_structure:string,pblade_special:string,pblade_vibrate:string,pblade_hitsize:string,pblade_thick:string,pblade_holdwidth:string,pblade_holdsize:string,pblade_madein:string,probber_property:string,probber_speed:string,probber_spin:string,probber_control:string,probber_hard:string,probber_madein:string,pothers_madein:string,pbrand:string) {
    this.pamount=1;
    this.pname=name;
    this.pprice = product;
    this.pid=productid;
    this.pimg=pimg;
    this.pdescription=pdescription;
    this.pcategory=pcategory;
    this.pblade_structure=pblade_structure;
    this.pblade_special=pblade_special;
    this.pblade_vibrate=pblade_vibrate;
    this.pblade_hitsize=pblade_hitsize;
    this.pblade_thick=pblade_thick;
    this.pblade_holdwidth=pblade_holdwidth;
    this.pblade_holdsize=pblade_holdsize;
    this.pblade_madein=pblade_madein;
    this.probber_property=probber_property;
    this.probber_speed=probber_speed;
    this.probber_spin=probber_spin;
    this.probber_control=probber_control;
    this.probber_hard=probber_hard;
    this.probber_madein=probber_madein;
    this.pothers_madein=pothers_madein;
    this.pbrand=pbrand;
  }

  gotoAbout(){
    this.router.navigate(['about']);
  }

  gotoClassroom(){
    this.router.navigate(['classroom']);
  }

  gotoNewDetail(){
    this.router.navigate(['newdetail']);
  }

  gotoNew(){
    this.router.navigate(['new']);
  }

  changeNum(pamount){
    this.pamount=pamount;
  }

  gotoDetail1(){
    this.router.navigate(['detail1']);
  }
  gotoDetail2(){
    this.router.navigate(['detail2']);
  }
  gotoDetail3(){
    this.router.navigate(['detail3']);
  }
  gotoDetail4(){
    this.router.navigate(['detail4']);
  }
  gotoDetail5(){
    this.router.navigate(['detail5']);
  }
  gotoDetail6(){
    this.router.navigate(['detail6']);
  }
  gotoDetail7(){
    this.router.navigate(['detail7']);
  }
  gotoDetail8(){
    this.router.navigate(['detail8']);
  }
  gotoDetail9(){
    this.router.navigate(['detail9']);
  }
  gotoDetail10(){
    this.router.navigate(['detail10']);
  }
  gotoDetail11(){
    this.router.navigate(['detail11']);
  }
  gotoDetail12(){
    this.router.navigate(['detail12']);
  }
  gotoDetail13(){
    this.router.navigate(['detail13']);
  }
  gotoDetail14(){
    this.router.navigate(['detail14']);
  }
  gotoDetail15(){
    this.router.navigate(['detail15']);
  }
  gotoDetail16(){
    this.router.navigate(['detail16']);
  }
  gotoDetail17(){
    this.router.navigate(['detail17']);
  }
  gotoDetail18(){
    this.router.navigate(['detail18']);
  }
  gotoDetail19(){
    this.router.navigate(['detail19']);
  }
  gotoDetail20(){
    this.router.navigate(['detail20']);
  }
  gotoDetail21(){
    this.router.navigate(['detail21']);
  }
  gotoDetail22(){
    this.router.navigate(['detail22']);
  }
  gotoDetail23(){
    this.router.navigate(['detail23']);
  }
  gotoDetail24(){
    this.router.navigate(['detail24']);
  }
  gotoDetail25(){
    this.router.navigate(['detail25']);
  }
  gotoDetail26(){
    this.router.navigate(['detail26']);
  }
  gotoDetail27(){
    this.router.navigate(['detail27']);
  }
  gotoDetail28(){
    this.router.navigate(['detail28']);
  }
  gotoDetail29(){
    this.router.navigate(['detail29']);
  }
  gotoDetail30(){
    this.router.navigate(['detail30']);
  }
  gotoDetail31(){
    this.router.navigate(['detail31']);
  }
  gotoDetail32(){
    this.router.navigate(['detail32']);
  }
  gotoDetail33(){
    this.router.navigate(['detail33']);
  }
  gotoDetail34(){
    this.router.navigate(['detail34']);
  }
  gotoDetail35(){
    this.router.navigate(['detail35']);
  }
  gotoDetail36(){
    this.router.navigate(['detail36']);
  }
  gotoDetail37(){
    this.router.navigate(['detail37']);
  }
  gotoDetail38(){
    this.router.navigate(['detail38']);
  }
  gotoDetail39(){
    this.router.navigate(['detail39']);
  }
  gotoDetail40(){
    this.router.navigate(['detail40']);
  }
  gotoDetail41(){
    this.router.navigate(['detail41']);
  }
  gotoDetail42(){
    this.router.navigate(['detail42']);
  }
  gotoDetail43(){
    this.router.navigate(['detail43']);
  }
  gotoDetail44(){
    this.router.navigate(['detail44']);
  }
  gotoDetail45(){
    this.router.navigate(['detail45']);
  }
  gotoDetail46(){
    this.router.navigate(['detail46']);
  }
  gotoDetail47(){
    this.router.navigate(['detail47']);
  }
  gotoDetail48(){
    this.router.navigate(['detail48']);
  }
  gotoDetail49(){
    this.router.navigate(['detail49']);
  }
  gotoDetail50(){
    this.router.navigate(['detail50']);
  }
  gotoDetail51(){
    this.router.navigate(['detail51']);
  }
  gotoDetail52(){
    this.router.navigate(['detail52']);
  }
  gotoDetail53(){
    this.router.navigate(['detail53']);
  }
  gotoDetail54(){
    this.router.navigate(['detail54']);
  }
  gotoDetail55(){
    this.router.navigate(['detail55']);
  }
  gotoDetail56(){
    this.router.navigate(['detail56']);
  }
  gotoDetail57(){
    this.router.navigate(['detail57']);
  }
  gotoDetail58(){
    this.router.navigate(['detail58']);
  }
  gotoDetail59(){
    this.router.navigate(['detail59']);
  }
  gotoDetail60(){
    this.router.navigate(['detail60']);
  }
  gotoDetail61(){
    this.router.navigate(['detail61']);
  }
  gotoDetail62(){
    this.router.navigate(['detail62']);
  }
  gotoDetail63(){
    this.router.navigate(['detail63']);
  }
  gotoDetail64(){
    this.router.navigate(['detail64']);
  }
  gotoDetail65(){
    this.router.navigate(['detail65']);
  }
  gotoDetail66(){
    this.router.navigate(['detail66']);
  }
  gotoDetail67(){
    this.router.navigate(['detail67']);
  }
  gotoDetail68(){
    this.router.navigate(['detail68']);
  }
  gotoDetail69(){
    this.router.navigate(['detail69']);
  }
  gotoDetail70(){
    this.router.navigate(['detail70']);
  }
  gotoDetail71(){
    this.router.navigate(['detail71']);
  }
  gotoDetail72(){
    this.router.navigate(['detail72']);
  }
  gotoDetail73(){
    this.router.navigate(['detail73']);
  }
  gotoDetail74(){
    this.router.navigate(['detail74']);
  }
  gotoDetail75(){
    this.router.navigate(['detail75']);
  }
  gotoDetail76(){
    this.router.navigate(['detail76']);
  }
  gotoDetail77(){
    this.router.navigate(['detail77']);
  }
  gotoDetail78(){
    this.router.navigate(['detail78']);
  }
  gotoDetail79(){
    this.router.navigate(['detail79']);
  }
  gotoDetail80(){
    this.router.navigate(['detail80']);
  }
  gotoDetail81(){
    this.router.navigate(['detail81']);
  }
  gotoDetail82(){
    this.router.navigate(['detail82']);
  }
  gotoDetail83(){
    this.router.navigate(['detail83']);
  }
  gotoDetail84(){
    this.router.navigate(['detail84']);
  }
  gotoDetail85(){
    this.router.navigate(['detail85']);
  }
  gotoDetail86(){
    this.router.navigate(['detail86']);
  }
  gotoDetail87(){
    this.router.navigate(['detail87']);
  }
  gotoDetail88(){
    this.router.navigate(['detail88']);
  }
  gotoDetail89(){
    this.router.navigate(['detail89']);
  }
  gotoDetail90(){
    this.router.navigate(['detail90']);
  }
  gotoDetail91(){
    this.router.navigate(['detail91']);
  }
  gotoDetail92(){
    this.router.navigate(['detail92']);
  }
  gotoDetail93(){
    this.router.navigate(['detail93']);
  }
  gotoDetail94(){
    this.router.navigate(['detail94']);
  }
  gotoDetail95(){
    this.router.navigate(['detail95']);
  }
  gotoDetail96(){
    this.router.navigate(['detail96']);
  }
  gotoDetail97(){
    this.router.navigate(['detail97']);
  }
  gotoDetail98(){
    this.router.navigate(['detail98']);
  }
  gotoDetail99(){
    this.router.navigate(['detail99']);
  }
  gotoDetail100(){
    this.router.navigate(['detail100']);
  }
  gotoDetail101(){
    this.router.navigate(['detail101']);
  }
  gotoDetail102(){
    this.router.navigate(['detail102']);
  }
  gotoDetail103(){
    this.router.navigate(['detail103']);
  }
  gotoDetail104(){
    this.router.navigate(['detail104']);
  }
  gotoDetail105(){
    this.router.navigate(['detail105']);
  }
  gotoDetail106(){
    this.router.navigate(['detail106']);
  }
  gotoDetail107(){
    this.router.navigate(['detail107']);
  }
  gotoDetail108(){
    this.router.navigate(['detail108']);
  }
  gotoDetail109(){
    this.router.navigate(['detail109']);
  }
  gotoDetail110(){
    this.router.navigate(['detail110']);
  }
  gotoDetail111(){
    this.router.navigate(['detail111']);
  }
  gotoDetail112(){
    this.router.navigate(['detail112']);
  }
  gotoDetail113(){
    this.router.navigate(['detail113']);
  }
  gotoDetail114(){
    this.router.navigate(['detail114']);
  }
  gotoDetail115(){
    this.router.navigate(['detail115']);
  }
  gotoDetail116(){
    this.router.navigate(['detail116']);
  }
  gotoDetail117(){
    this.router.navigate(['detail117']);
  }
  gotoDetail118(){
    this.router.navigate(['detail118']);
  }
  gotoDetail119(){
    this.router.navigate(['detail119']);
  }
  gotoDetail120(){
    this.router.navigate(['detail120']);
  }
  gotoDetail121(){
    this.router.navigate(['detail121']);
  }
  gotoDetail122(){
    this.router.navigate(['detail122']);
  }
  gotoDetail123(){
    this.router.navigate(['detail123']);
  }
  gotoDetail124(){
    this.router.navigate(['detail124']);
  }
  gotoDetail125(){
    this.router.navigate(['detail125']);
  }
  gotoDetail126(){
    this.router.navigate(['detail126']);
  }
  gotoDetail127(){
    this.router.navigate(['detail127']);
  }
  gotoDetail128(){
    this.router.navigate(['detail128']);
  }
  gotoDetail129(){
    this.router.navigate(['detail129']);
  }
  gotoDetail130(){
    this.router.navigate(['detail130']);
  }
  gotoDetail131(){
    this.router.navigate(['detail131']);
  }
  gotoDetail132(){
    this.router.navigate(['detail132']);
  }
  gotoDetail133(){
    this.router.navigate(['detail133']);
  }
  gotoDetail134(){
    this.router.navigate(['detail134']);
  }
  gotoDetail135(){
    this.router.navigate(['detail135']);
  }
  gotoDetail136(){
    this.router.navigate(['detail136']);
  }
  gotoDetail137(){
    this.router.navigate(['detail137']);
  }
  gotoDetail138(){
    this.router.navigate(['detail138']);
  }
  gotoDetail139(){
    this.router.navigate(['detail139']);
  }
  gotoDetail140(){
    this.router.navigate(['detail140']);
  }
  gotoDetail141(){
    this.router.navigate(['detail141']);
  }
  gotoDetail142(){
    this.router.navigate(['detail142']);
  }
  gotoDetail143(){
    this.router.navigate(['detail143']);
  }
  gotoDetail144(){
    this.router.navigate(['detail144']);
  }
  gotoDetail145(){
    this.router.navigate(['detail145']);
  }
  gotoDetail146(){
    this.router.navigate(['detail146']);
  }
  gotoDetail147(){
    this.router.navigate(['detail147']);
  }
  gotoDetail148(){
    this.router.navigate(['detail148']);
  }
  gotoDetail149(){
    this.router.navigate(['detail149']);
  }
  gotoDetail150(){
    this.router.navigate(['detail150']);
  }
  gotoDetail151(){
    this.router.navigate(['detail151']);
  }
  gotoDetail152(){
    this.router.navigate(['detail152']);
  }
  gotoDetail153(){
    this.router.navigate(['detail153']);
  }
  gotoDetail154(){
    this.router.navigate(['detail154']);
  }
  gotoDetail155(){
    this.router.navigate(['detail155']);
  }
  gotoDetail156(){
    this.router.navigate(['detail156']);
  }
  gotoDetail157(){
    this.router.navigate(['detail157']);
  }
  gotoDetail158(){
    this.router.navigate(['detail158']);
  }
  gotoDetail159(){
    this.router.navigate(['detail159']);
  }
  gotoDetail160(){
    this.router.navigate(['detail160']);
  }
  gotoDetail161(){
    this.router.navigate(['detail161']);
  }
  gotoDetail162(){
    this.router.navigate(['detail162']);
  }
  gotoDetail163(){
    this.router.navigate(['detail163']);
  }
  gotoDetail164(){
    this.router.navigate(['detail164']);
  }
  gotoDetail165(){
    this.router.navigate(['detail165']);
  }
  gotoDetail166(){
    this.router.navigate(['detail166']);
  }
  gotoDetail167(){
    this.router.navigate(['detail167']);
  }
  gotoDetail168(){
    this.router.navigate(['detail168']);
  }
  gotoDetail169(){
    this.router.navigate(['detail169']);
  }
  gotoDetail170(){
    this.router.navigate(['detail170']);
  }
  gotoDetail171(){
    this.router.navigate(['detail171']);
  }
  gotoDetail172(){
    this.router.navigate(['detail172']);
  }
  gotoDetail173(){
    this.router.navigate(['detail173']);
  }
  gotoDetail174(){
    this.router.navigate(['detail174']);
  }
  gotoDetail175(){
    this.router.navigate(['detail175']);
  }
  gotoDetail176(){
    this.router.navigate(['detail176']);
  }
  gotoDetail177(){
    this.router.navigate(['detail177']);
  }
  gotoDetail178(){
    this.router.navigate(['detail178']);
  }
  gotoDetail179(){
    this.router.navigate(['detail179']);
  }
  gotoDetail180(){
    this.router.navigate(['detail180']);
  }
  gotoDetail181(){
    this.router.navigate(['detail181']);
  }
  gotoDetail182(){
    this.router.navigate(['detail182']);
  }
  gotoDetail183(){
    this.router.navigate(['detail183']);
  }
  gotoDetail184(){
    this.router.navigate(['detail184']);
  }
  gotoDetail185(){
    this.router.navigate(['detail185']);
  }
  gotoDetail186(){
    this.router.navigate(['detail186']);
  }
  gotoDetail187(){
    this.router.navigate(['detail187']);
  }
  gotoDetail188(){
    this.router.navigate(['detail188']);
  }
  gotoDetail189(){
    this.router.navigate(['detail189']);
  }
  gotoDetail190(){
    this.router.navigate(['detail190']);
  }
  gotoDetail191(){
    this.router.navigate(['detail191']);
  }
  gotoDetail192(){
    this.router.navigate(['detail192']);
  }
  gotoDetail193(){
    this.router.navigate(['detail193']);
  }
  gotoDetail194(){
    this.router.navigate(['detail194']);
  }
  gotoDetail195(){
    this.router.navigate(['detail195']);
  }
  gotoDetail196(){
    this.router.navigate(['detail196']);
  }
  gotoDetail197(){
    this.router.navigate(['detail197']);
  }
  gotoDetail198(){
    this.router.navigate(['detail198']);
  }
  gotoDetail199(){
    this.router.navigate(['detail199']);
  }
  gotoDetail200(){
    this.router.navigate(['detail200']);
  }
  gotoDetail201(){
    this.router.navigate(['detail201']);
  }
  gotoDetail202(){
    this.router.navigate(['detail202']);
  }
  gotoDetail203(){
    this.router.navigate(['detail203']);
  }
  gotoDetail204(){
    this.router.navigate(['detail204']);
  }
  gotoDetail205(){
    this.router.navigate(['detail205']);
  }
  gotoDetail206(){
    this.router.navigate(['detail206']);
  }
  gotoDetail207(){
    this.router.navigate(['detail207']);
  }
  gotoDetail208(){
    this.router.navigate(['detail208']);
  }
  gotoDetail209(){
    this.router.navigate(['detail209']);
  }
  gotoDetail210(){
    this.router.navigate(['detail210']);
  }
  gotoDetail211(){
    this.router.navigate(['detail211']);
  }
  gotoDetail212(){
    this.router.navigate(['detail212']);
  }
  gotoDetail213(){
    this.router.navigate(['detail213']);
  }
  gotoDetail214(){
    this.router.navigate(['detail214']);
  }
  gotoDetail215(){
    this.router.navigate(['detail215']);
  }
  gotoDetail216(){
    this.router.navigate(['detail216']);
  }
  gotoDetail217(){
    this.router.navigate(['detail217']);
  }
  gotoDetail218(){
    this.router.navigate(['detail218']);
  }
  gotoDetail219(){
    this.router.navigate(['detail219']);
  }
  gotoDetail220(){
    this.router.navigate(['detail220']);
  }
  }


// WEBPACK FOOTER //
// ./src/app/Home/home.component.ts